export default __webpack_public_path__ + "static/media/cash_management.f49e94dc.svg";